// material
import { Box } from '@mui/material';
import { SxProps } from '@mui/system';
import { useSettings } from '../../../hooks';
import { useIsManager } from '../../../hooks';
import { useIsPolicyStreamOrganization } from '../../PolicyStream/hooks/useIsPolicyStreamOrganization';

// import testSettings from '../../../WhiteLabelSettings/Calefy/settings'
// import testSettings from '../../../WhiteLabelSettings/FuseInsurance/settings'
// import testSettings from '../../../WhiteLabelSettings/VapeInsurance/settings'
// import testSettings from '../../../WhiteLabelSettings/CannabisInsurance/settings'
// import testSettings from '../../../WhiteLabelSettings/LastnameInsurance/settings';

// ----------------------------------------------------------------------

const CALEFY_SQUARE_LOGO_LOCATION = '/static/brand/CalefyIconLogo.png';
const POLICYSTREAM_SQUARE_LOGO_LOCATION =
  '/policystream/policystreamSquareLogo.png';

type LogoProps = {
  sx?: SxProps;
};
/**
 * Returns a square logo for the current organization / website
 * @param sx - the MaterialUI sx
 */
export default function Logo({ sx }: LogoProps) {
  // const onPolicystream = useInPolicystream();
  const onPolicystream = useIsPolicyStreamOrganization();
  const { isManager } = useIsManager();
  const { settings } = useSettings();

  const { squareLogo } = settings;
  const defaultSquareLogo = onPolicystream
    ? POLICYSTREAM_SQUARE_LOGO_LOCATION
    : CALEFY_SQUARE_LOGO_LOCATION;
  const src = !isManager && squareLogo ? squareLogo : defaultSquareLogo;

  return (
    <Box
      component='img'
      alt='logo'
      src={src}
      sx={{
        width: onPolicystream ? 80 : 40,
        height: onPolicystream ? 80 : 40,
        ...sx,
      }}
    />
  );
}
